export const getProductRoutes = `
  query GetProductRoutes{
    entries(
    type: ["vino", "birra", "prodottoAgricoltura", "prodottoNutraceutica", "prodottoPanificati"]
    limit: 1000
  ){
      id
      slug
    }
  }
`
